const ENCRYPTION_SECRET = process.env.REACT_APP_ENCRYPTION_SECRET_KEY || "";

function base64UrlDecode(str: string): ArrayBuffer {
  let s = str.replace(/-/g, "+").replace(/_/g, "/");

  while (s.length % 4) {
    s += "=";
  }

  const binary = atob(s);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes.buffer.slice(0);
}

async function getKey(): Promise<CryptoKey> {
  const secretBytes = new TextEncoder().encode(ENCRYPTION_SECRET);

  const hash = await window.crypto.subtle.digest("SHA-256", secretBytes);

  return window.crypto.subtle.importKey(
    "raw",
    hash,
    {
      name: "AES-GCM",
    },
    false,
    ["decrypt"],
  );
}

export async function decrypt(encryptedText: string): Promise<string | null> {
  try {
    console.log("Encrypted Input:", encryptedText);

    const parts = encryptedText.split(".");

    console.log("PARTS", parts);

    if (parts.length !== 3) {
      throw new Error(
        `Invalid encrypted format. Expected 3 parts but got ${parts.length}`,
      );
    }

    const [ivEncoded, dataEncoded, tagEncoded] = parts;

    const iv = base64UrlDecode(ivEncoded);
    const ciphertext = new Uint8Array(base64UrlDecode(dataEncoded));
    const authTag = new Uint8Array(base64UrlDecode(tagEncoded));

    console.log({
      ivLength: iv.byteLength,
      ciphertextLength: ciphertext.length,
      authTagLength: authTag.length,
    });

    // AES-GCM in browser expects ciphertext + authTag
    const encryptedData = new Uint8Array(ciphertext.length + authTag.length);

    encryptedData.set(ciphertext);
    encryptedData.set(authTag, ciphertext.length);

    const key = await getKey();

    const decryptedBuffer = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
        tagLength: 128,
      },
      key,
      encryptedData.buffer,
    );

    const result = new TextDecoder().decode(decryptedBuffer);

    console.log("Decrypted Result:", result);

    return result;
  } catch (err) {
    console.error("Decrypt failed:", err);
    return null;
  }
}
